
export function InstrucoesCnc() {

    return (
        <div className="text-lg">
            <div ><span className="font-bold">1.</span> Consulte a escala de trabalho (gráfico gant) e o chefe do setor.</div>
            <hr className="mb-5" />
            <div><span className="font-bold">2.</span> Consulte dados da obra em APPRodrimaq&gt;Obras&gt;Data de entrega xxx&gt;CNC</div>
            <hr className="mb-5" />
            <div className="mb-2"><span className="font-bold">3.</span> Fase I – Programação CAM</div>
            <div className="ml-10">
                <div className="mb-2"><span className="font-bold">a.</span> Situar no TopSolid o projeto-cliente e o nº de obra;</div>
                <div className="mb-2"><span className="font-bold">b.</span> Atribuir programa de maquinação;</div>
            </div>
            <hr className="mb-5" />
            <div ><span className="font-bold">4.</span>  Fase II – Maquinação CNC</div>
            <div className="ml-10">
                <div className="mb-2"><span className="font-bold">a.</span> Recolher material na estante e preparação de máquina;</div>
                <div className="mb-2"><span className="font-bold">b.</span> Maquinação de peças;</div>
            </div>
            <hr className="mb-5" />
            <div ><span className="font-bold">5.</span> Devolver à secção ‘Acabamentos’ o produto acabado com a respetiva identificação inicial.</div>
            <hr className="mb-5" />
            <div className="mt-10"><span className="font-bold">Notas:</span> Peças NOK devem ser colocadas na caixa vermelha existente no setor com indicação a vermelho do(s)
                defeito(s). Tente, sempre que possível, manter o setor limpo e organizado.</div>

        </div>
    )

}